var t=String,n=function(r){try{return t(r)}catch{return"Object"}};export{n as default};
